import React from 'react';
import IdNameActiveEntity from './IdNameActiveEntity';

export default class AdminRegionEntity extends IdNameActiveEntity {

  static shape = {
    id: React.PropTypes.string.isRequired,
    name: React.PropTypes.string.isRequired,
    national: React.PropTypes.bool.isRequired,
    active: React.PropTypes.bool.isRequired,
  };

  static newRegion = () => new AdminRegionEntity({
    name: '',
    national: false,
  });

  static validateName = (name) => {
    if (!name || /^\s*$/.test(name)) {
      return 'Veuillez saisir un nom';
    }
    if (name.length > 32) {
      return 'Le nom doit faire au plus 32 caractères';
    }
    return undefined;
  };
}



// WEBPACK FOOTER //
// ./shared/src/entity/AdminRegionEntity.js